import { DEFAULT_USER, type User } from '@/schemas/user.schema'

const USER_PROFILE_KEY = 'slope_sync_user_profile'

export function getUser(): User {
  try {
    const data = window.localStorage.getItem(USER_PROFILE_KEY)
    if (!data) return DEFAULT_USER

    const parsed = JSON.parse(data)
    return (parsed as User) ?? DEFAULT_USER
  } catch {
    return DEFAULT_USER
  }
}

function saveUser(user: Partial<User>): void {
  try {
    window.localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(user))
  } catch (error) {
    console.error('Failed to save user profile', error)
  }
}

function clearUser(): void {
  try {
    window.localStorage.removeItem(USER_PROFILE_KEY)
  } catch (error) {
    console.error('Failed to clear user profile', error)
  }
}

export const tokenService = {
  getUser: getUser,
  saveUser: saveUser,
  clear: clearUser,
}
